import Cookies from 'js-cookie';
import type { ReverseAnalyticsData } from 'services/clickstream';
import type { PayHubCashierContractsPendingWithdrawalResponse } from 'store/models';
import { getWidgetLocation } from 'utils';
import { toBig } from 'utils/math/math';

export const FULL_REVERSE_PERCENT = 100;

export enum ReversePopupType {
  partial = 'partial',
  full = 'full',
  none = 'none',
}

interface ReversePopupTypeParams {
  withdrawalReverseAmount?: number;
  pendingWithdrawals: PayHubCashierContractsPendingWithdrawalResponse[];
  isPartialReverseEnabled: boolean;
}

const hasPartialOption = ({ available_options }: PayHubCashierContractsPendingWithdrawalResponse) =>
  available_options.some((option) => option < FULL_REVERSE_PERCENT);

export const getReversePopupType = ({
  withdrawalReverseAmount,
  pendingWithdrawals,
  isPartialReverseEnabled,
}: ReversePopupTypeParams): ReversePopupType => {
  if (isPartialReverseEnabled && pendingWithdrawals.some(hasPartialOption)) {
    return ReversePopupType.partial;
  }

  if (withdrawalReverseAmount) {
    return ReversePopupType.full;
  }

  return ReversePopupType.none;
};

export const getFullReverseAnalyticsData = (amount?: number): ReverseAnalyticsData => ({
  option: FULL_REVERSE_PERCENT,
  return_amount: amount === undefined ? null : toBig(amount).toFixed(),
  remain_amount: '0',
  transaction_count: null,
});

export const isWithdrawalRejectBilletClosedCookieSet = (): boolean =>
  Boolean(Cookies.get('withdrawalRejectBilletClosed'));

export const setWithdrawalRejectBilletClosedCookies = (): void => {
  Cookies.set('withdrawalRejectBilletClosed', '1', {
    expires: 3, // days
    secure: true, // because without this parameter (true) - cookie do not set in iFrame
    sameSite: 'none',
  });
};

export const isPathnameOkForWithdrawalReject = (pathname: string): boolean => {
  const { isDeposit, isDepositForm } = getWidgetLocation(pathname);

  return isDeposit || isDepositForm;
};
